export enum StatisticsRoute {
  statisticsMain = 'Statistics Main',
  statisticsPlayer = 'Statistics Player',
  statisticsGame = 'Statisitics Game',
  downloadCV = 'Download CV'
}
